export const style = {
  container: {
    padding: "1.2rem 0.8rem",
    borderBottom: "0.1rem solid var(--gray-20)",
    background: "var(--neutral-100)",
    cursor: "pointer",
    width: "100%",
  },
  availabilityCommon: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleIconContainer: {
    display: "flex",
    alignItems: "flex-start",
  },
  availabilityInfoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "0.4rem",
  },
  headerText: {
    color: "var(--black-900)",
    fontSize: "1.4rem",
    fontWeight: 500,
  },
  totalAvailabilityText: {
    color: "var(--gray-400)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
};
